import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { Button } from './components/ui/button'

const Documentation = () => {
    const { t } = useTranslation()

    return (
        <section className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8 space-y-12">
            <div>
                <h2 className="text-3xl font-bold tracking-tight">{t('docs.servicesTitle')}</h2>
                <p className="mt-4 text-muted-foreground leading-relaxed">{t('docs.servicesText')}</p>
            </div>
            <div>
                <h2 className="text-3xl font-bold tracking-tight">{t('docs.consultantsTitle')}</h2>
                <p className="mt-4 text-muted-foreground leading-relaxed">{t('docs.consultantsText')}</p>
            </div>
            <div>
                <h2 className="text-3xl font-bold tracking-tight">{t('docs.sdkTitle')}</h2>
                <p className="mt-4 text-muted-foreground leading-relaxed">
                    {t('docs.sdkText')} Visit{' '}
                    <a href="https://github.com/mvdatacenter/mvdata-sdk-go/" className="text-primary hover:underline">
                        {t('docs.sdkLink')}
                    </a>{' '}
                    for more information.
                </p>
            </div>
            <div>
                <h2 className="text-3xl font-bold tracking-tight">{t('docs.terraformTitle')}</h2>
                <p className="mt-4 text-muted-foreground leading-relaxed">
                    {t('docs.terraformText')} For more information, visit{' '}
                    <a href="https://github.com/mvdatacenter/terraform-provider-mvdata" className="text-primary hover:underline">
                        {t('docs.terraformLink')}
                    </a>.
                </p>
            </div>
            <Link to="/pricing">
                <Button size="lg" className="mt-4">{t('docs.seePricing')}</Button>
            </Link>
        </section>
    )
}

export default Documentation
